import SectionHeader from "components/Common/SectionHeader"
import { Badge, Card, CardBody } from "reactstrap"
import { formatReadableDate } from "utils/formatDate"
import ButtonTooltip from "components/Common/ButtonTooltip"
import StockAdditionalInfoUpdate from "./StockAdditionalInfoUpdate"
import ThemePlaceholder from "components/Common/ThemePlaceholder"
import { useImageViewer } from "hooks/useImageViewer"
import FileViewerModal from "components/Common/FileViewerModal"

export default function AdditionalInformation({ stock, loading = false }) {
  const {
    viewerOpen,
    selectedImageUrl,
    imageTitle,
    openImageViewer,
    closeImageViewer,
  } = useImageViewer()

  const renderFile = (file, id) => {
    if (loading) {
      return (
        <ThemePlaceholder style={{ width: 100, height: 20, borderRadius: 4 }} />
      )
    }

    if (!file) return <Badge color="secondary">Not Available</Badge>

    const isPdf =
      file?.url?.toLowerCase().endsWith(".pdf") ||
      file?.type === "application/pdf"

    return (
      <div className="d-flex align-items-center gap-2">
        <Badge color="success">Available</Badge>
        <ButtonTooltip
          type="view"
          btnId={`view-${id}`} // unique ID for tooltip
          btnName={isPdf ? "View PDF" : "View Image"}
          onClick={() =>
            openImageViewer(
              file.url,
              id === "auction_sheet"
                ? "Auction Sheet"
                : id === "true_report"
                ? "True Report"
                : "Document"
            )
          }
        />
      </div>
    )
  }

  const infoList = [
    {
      label: "Stock Added",
      value: stock?.created_at ? formatReadableDate(stock.created_at) : "-",
    },
    {
      label: "Last Modified",
      value: stock?.updated_at ? formatReadableDate(stock.updated_at) : "-",
    },
    {
      label: "Auction Sheet",
      value: stock?.auction_sheet,
      render: file => renderFile(file, "auction_sheet"),
    },
    {
      label: "True Report",
      value: stock?.true_report,
      render: file => renderFile(file, "true_report"),
    },
    {
      label: "Other Documents",
      value: stock?.documents,
      render: file => renderFile(file, "documents"),
    },
  ]

  return (
    <Card className="border-0 shadow-sm mt-4">
      <CardBody className="p-3">
        <SectionHeader
          icon="bx bx-info-circle"
          title="Additional Information"
          action={loading ? null : <StockAdditionalInfoUpdate stock={stock} />}
        />
        <div className="specs-list">
          {infoList.map((item, index) => (
            <div
              key={index}
              className="d-flex justify-content-between py-2 border-bottom"
            >
              <span className="text-muted">{item.label}:</span>
              {item.render ? (
                item.render(item.value)
              ) : loading ? (
                <ThemePlaceholder
                  style={{ width: 150, height: 20, borderRadius: 4 }}
                />
              ) : (
                <span className="fw-medium">{item.value}</span>
              )}
            </div>
          ))}
        </div>

        <FileViewerModal
          isOpen={viewerOpen}
          onClose={closeImageViewer}
          fileUrl={selectedImageUrl}
          fileName={imageTitle}
        />
      </CardBody>
    </Card>
  )
}
